ko.components.register('manage-tasks', {
	viewModel: function(opts) {
		var self = this;

		self.loading = ko.observable(false);

		self.resetText = ko.observable(opts.resetText || 'Reset');
		self.loadingText = ko.observable(opts.loadingText || 'Loading...');

		self.parseTasksLabelText = ko.observable(opts.parseTasksLabelText || 'Parse Tasks');
		self.crawlTasksLabelText = ko.observable(opts.crawlTasksLabelText || 'Crawl Tasks');

		self.parseTasksCount = ko.observable(parseInt(opts.parseTasksCount || 0));
		self.crawlTasksCount = ko.observable(parseInt(opts.crawlTasksCount || 0));

		self.readOnly = ko.observable(!!(opts.readOnly || 0));

		// internal, type can be set to 'parse' or 'crawl'
		self.resetTasks = function(type){
			if(self.loading())
				return;
			self.loading(true);
			App.ajaxRequest('tasks/reset', {'type': type}, function(r){
				if(r) {
					if(r.parseTasksCount)
						self.parseTasksCount(parseInt(r.parseTasksCount));
					if(r.crawlTasksCount)
						self.crawlTasksCount(parseInt(r.crawlTasksCount));
					if(r.error)
						alert(r.error);
				}
			}).always(function(){
				self.loading(false);
			}).fail(function(){
				alert('Request failed.');
			});
		};

		self.resetParseTasks = function(){
			self.resetTasks('parse');
		};

		self.resetCrawlTasks = function(){
			self.resetTasks('crawl');
		};

	},
	template: "<table class=\"table table-striped manage-tasks mb-0\">\n<tr>\n\t<th class=\"w-50\" data-bind=\"text: parseTasksLabelText\"></th>\n\t<td>\n\t\t<span data-bind=\"text: parseTasksCount\"></span>\n\t\t<small class=\"text-gray\" data-bind=\"visible: loading(), text: loadingText()\"></small>\n\t\t<button class=\"btn btn-outline-danger btn-sm ml-3\" data-bind=\"visible: (!readOnly() && parseTasksCount() > 0 && !loading()), text: resetText(), click: resetParseTasks\"></button>\n\t</td>\n</tr>\n<tr>\n\t<th class=\"w-50\" data-bind=\"text: crawlTasksLabelText\"></th>\n\t<td>\n\t\t<span data-bind=\"text: crawlTasksCount\"></span>\n\t\t<small class=\"text-gray\" data-bind=\"visible: loading(), text: loadingText()\"></small>\n\t\t<button class=\"btn btn-outline-danger btn-sm ml-3\" data-bind=\"visible: (!readOnly() && crawlTasksCount() > 0 && !loading()), text: resetText(), click: resetCrawlTasks\"></button>\n\t</td>\n</tr>\n</table>"
});
